import graphqlClient from './client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation SendBulkProspectEmail(
    $prospectIds: [ID!]!
    $subject: String!
    $message: String!
    $enableReplies: Boolean!
  ) {
    sendBulkProspectEmail(
      input: {
        prospectIds: $prospectIds
        subject: $subject
        message: $message
        enableReplies: $enableReplies
      }
    ) {
      success
    }
  }
` as any;

interface BulkProspectEmailPayload {
  success: boolean;
}
interface BulkProspectEmailData {
  sendBulkProspectEmail: BulkProspectEmailPayload;
}

export declare interface BulkProspectEmailResult {
  data: BulkProspectEmailData;
}

const sendBulkProspectEmail = async (
  prospectIds: string[],
  subject: string,
  message: string,
  enableReplies: boolean,
): Promise<any> => {
  const { data } = (await graphqlClient.mutate({
    variables: { prospectIds, subject, message, enableReplies },
    mutation,
  })) as BulkProspectEmailResult;

  return {
    ...data.sendBulkProspectEmail,
  };
};

export default sendBulkProspectEmail;
